import { ChallanCard } from './ChallanCard';
import { formatCurrency, type Challan } from '../data/challans';
import styles from './ChallanList.module.css';

interface ChallanListProps {
  challans: Challan[];
}

export function ChallanList({ challans }: ChallanListProps) {
  const unpaid = challans.filter((c) => c.status === 'Unpaid');
  const totalDue = unpaid.reduce((sum, c) => sum + c.amount, 0);

  return (
    <section className={styles.listSection}>
      <div className={styles.header}>
        <div className={styles.titleBlock}>
          <h1 className={styles.title}>Your challans</h1>
          <span className={styles.count}>{challans.length} found</span>
        </div>
        {unpaid.length > 0 && (
          <div className={styles.summary}>
            <span className={styles.summaryLabel}>Due</span>
            <span className={styles.summaryAmount}>{formatCurrency(totalDue)}</span>
          </div>
        )}
      </div>

      <div className={styles.cards}>
        {challans.map((challan) => (
          <ChallanCard key={challan.id} challan={challan} />
        ))}
      </div>
    </section>
  );
}
